import { B2BhubSpotEndPoint, ContentTypes } from '../constants';
import { NewsletterSignUpObject } from '../models/commonTypeScript';
import { fetchOutsideAirthings } from './fetch';
import getFetchHeaders from './getFetchHeaders';

export default async (data: NewsletterSignUpObject, isB2B: boolean): Promise<void> => {
    if (!isB2B) {
        return;
    }
    await fetchOutsideAirthings<void>(
        B2BhubSpotEndPoint,
        {
            method: 'POST',
            headers: await getFetchHeaders(),
            body: JSON.stringify(data),
        },
        ContentTypes.JSON
    );
};
